<div class="radius-10 bg-white full-width"
     [class.mat-elevation-z3]="tableStyle == 'custom'"
     fxLayout="column">

<!--  SINGLE LEASES-->

  @if (leaseSpaceDataSource) {

    <table mat-table [class]="tableStyle == 'dashboard' ? 'dashboard-table' : 'custom-table'"
           [dataSource]="leaseSpaceDataSource" matSort>

      @if (tableStyle == 'custom') {
        <ng-container matColumnDef="table-label">
          <th mat-header-cell class="custom-table-label" *matHeaderCellDef
              [attr.colspan]="displayedSpaceColumns.length"> Lease Spaces
          </th>
        </ng-container>
      }

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID</th>
        <td mat-cell class="custom-table-cell btn-cursor"
            matTooltip="Copy to clipboard" [cdkCopyToClipboard]="element.uuid"
            *matCellDef="let element"> {{ utils.displayUuid(element.uuid) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="spaceName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Space Name</th>
        <td mat-cell class="custom-table-cell"
            *matCellDef="let element"> {{ utils.displayString(element.spaceName, 20) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef> Size (sum)</th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{ element.spaceSize }} m<sup>2</sup></td>
      </ng-container>

      <ng-container matColumnDef="leaseStartDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Start Date</th>
        <td mat-cell class="custom-table-cell"
            *matCellDef="let element"> {{ dateUtils.displayShortDate(element.leaseStartDate) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="leaseEndDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> End Date</th>
        <td mat-cell class="custom-table-cell"
            *matCellDef="let element"> {{ dateUtils.displayShortDate(element.leaseEndDate) }}
        </td>
      </ng-container>

      @if (tableStyle == 'custom') {
        <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
      }
      <tr mat-header-row class="custom-table-header" style="color: black !important;"
          *matHeaderRowDef="displayedSpaceColumns"></tr>
      <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedSpaceColumns;"></tr>
    </table>
  }

<!--  SUB LEASES-->

  @if (sharedSpacesDataSource) {
    <table mat-table [class]="tableStyle == 'dashboard' ? 'dashboard-table' : 'custom-table'"
           [dataSource]="sharedSpacesDataSource" matSort>

      @if (tableStyle == 'custom') {
        <ng-container matColumnDef="table-label">
          <th mat-header-cell class="custom-table-label" *matHeaderCellDef
              [attr.colspan]="displayedSharedSpaceColumns.length"> Lease Spaces
          </th>
        </ng-container>
      }

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID</th>
        <td mat-cell class="custom-table-cell btn-cursor"
            matTooltip="Copy to clipboard" [cdkCopyToClipboard]="element.uuid"
            *matCellDef="let element"> {{ utils.displayUuid(element.uuid) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="occupiedSpace">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Occupied Space</th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{ element.occupiedSpace }} m<sup>2</sup></td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Start Date</th>
        <td mat-cell class="custom-table-cell"
            *matCellDef="let element"> {{ dateUtils.displayShortDate(element.startDate) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> End Date</th>
        <td mat-cell class="custom-table-cell"
            *matCellDef="let element"> {{ dateUtils.displayShortDate(element.endDate) }}
        </td>
      </ng-container>

      @if (tableStyle == 'custom') {
        <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
      }
      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedSharedSpaceColumns"></tr>
      <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedSharedSpaceColumns;"></tr>
    </table>
  }

  <mat-paginator #paginator class="custom-paginator"
                 [length]="dataSource ? dataSource.data.length : 0"
                 [pageSize]="5"
                 [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
